export const Input = {
  components: {
    Input: {
      baseStyle: {
        field: {
          fontWeight: 400,
          borderRadius: "md",
          color: "black",
        },
      },
      defaultProps: {
        focusBorderColor: "brand.primary.200",
        size: "md",
        variant: "main",
      },
      variants: {
        main: (props) => ({
          field: {
            bg: props.colorMode === "light" ? "white" : "gray.800",
            border: "1px solid",
            color: props.colorMode === "light" ? "black" : "white",
            borderColor: props.colorMode === "light" ? "gray.300" : "white",
            fontSize: "md",
            _placeholder: { color: "gray.400" },
          },
        }),
        transparent: {
          field: {
            p: 0,
            border: "1px solid ",
            borderColor: "transparent",
            bg: "transparent",
            _readOnly: {
              boxShadow: "none !important",
              userSelect: "all",
            },
            _disabled: {
              opacity: 0.4,
              cursor: "not-allowed",
            },
            _invalid: {},
            _focusVisible: {
              zIndex: 1,
            },
          },
          addon: {
            border: "1px solid",
            // borderColor: mode("inherit", "whiteAlpha.50")(props),
            // bg: mode("gray.100", "whiteAlpha.300")(props),
          },
        },
      },
    },
    Select: {
      baseStyle: {
        field: {
          cursor: "pointer",
          fontWeight: 400,
        },
      },

      variants: {
        main: (props) => ({
          field: {
            bg: props.colorMode === "light" ? "white" : "gray.800",
            border: "1px solid",
            color: "black",
            borderColor: props.colorMode === "light" ? "gray.300" : "white",
            borderRadius: "md",
            _placeholder: { color: "gray.400" },
          },
        }),
      },
    },
  },
};
